import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { Breadcrumb, Button, Modal, Form, Col, FormGroup, ControlLabel } from 'react-bootstrap'
import { browserHistory } from 'react-router'

import Collapsible from './collapsible'
import EmailInvoice from './emailinvoice'
import Loadable from 'react-loading-overlay'
import SavedCardForm from './invoices/savedcardform'
import CreatePackingSlip from './invoices/createpackingslipmodal'

@observer(['globals', 'companies', 'contacts', 'quotes', 'quickbooks'])
export default class Quotes extends Component {

  constructor(props) {
    super(props)

    this.state = {
      loadableState: false,
      emailModalOpen: false,
      showPaymentModal: false,
      quoteToken: '',
      openCreatePackingSlipModal: false,
      quoteId: 0,
      activeRow: {
        companyId: 0,
        token: ''
      }
    }

    this.props.globals.setCurrentPage('quotes')
    this.props.quotes.loadQuotes()
  }

  setLoadableState(state) {
    this.setState({
        loadableState: state
    })
  }

  quoteIdFormatter(cell, row) {
    return cell
  }

  priceFormatter(cell, row) {
    return '$' + cell.toFixed(2)
  }

  percentFormatter(cell, row) {
    return cell + '%'
  }

  deleteQuote(id) {
    if (confirm('Are you sure you want to delete this quote?  This action cannot be undone!')) {
      this.props.quotes.deleteQuote(id, () => { this.props.quotes.loadQuotes() })
    }
  }

  quoteToOrder(row) {
    if (confirm('Are you sure you want to turn this quote into an order?  This action cannot be undone!')) {
      this.setState({
        loadableState: true
      })

      //if (row.oneTimeTotal > 0) {
        this.props.quickbooks.getQuickbooksCompanyItems((qbItemArray) => {
          this.props.quickbooks.getQuickbooksTerms((qbTermArray) => {
            this.props.quickbooks.getQuickbooksTaxRates((qbTaxRateArray) => {
              this.props.quotes.loadQuote(row.id, qbItemArray, qbTermArray, qbTaxRateArray, (quote) => {
                this.props.companies.loadCompanyDetails({ id: quote.companyId }, (company) => {
                  this.props.quotes.loadQuoteHardware(row.id, qbItemArray, (hardware) => {
                    this.props.quotes.loadQuoteAccessory(row.id, qbItemArray, (accessories) => {
                      this.props.quotes.loadQuoteFeature(row.id, qbItemArray, (features) => {

                        let today = new Date()

                        let quoteInfo = {
                          companyId: company.id,
                          qbCustomerId: company.qbCustomerId,
                          txnDate: ((today.getUTCMonth() + 1) + '-' + today.getUTCDate() + '-' + today.getUTCFullYear()),
                          note: quote.note,
                          paymentTermId: quote.paymentTermId,
                          taxRateId: quote.taxRateId,
                          billingCompany: quote.companyName,
                          billingName: quote.billingAddressName,
                          billingAddress: quote.billingAddressAddress,
                          billingCity: quote.billingAddressCity,
                          billingState: quote.billingAddressState,
                          billingZipCode: quote.billingAddressZipCode,
                          shippingName: quote.shippingAddressName,
                          shippingAddress: quote.shippingAddressAddress,
                          shippingCity: quote.shippingAddressCity,
                          shippingState: quote.shippingAddressState,
                          shippingZipCode: quote.shippingAddressZipCode,
                          shippingCost: quote.shippingCost,
                          email: company.contactEmail,
                          hardwareList: JSON.stringify(hardware).replace(/"/g, '\\"'),
                          accessoryList: JSON.stringify(accessories).replace(/"/g, '\\"'),
                          //featureList: JSON.stringify(features).replace(/"/g, '\\"')
                          featureList: "[]" //We do not need to send features as they are part of the monthly service and not one time fees.
                        }

                        this.props.quickbooks.quickbooksCreateInvoice(quoteInfo, (data) => {
                          if (data.quickbooksCreateInvoice.statusCode == 200) {
                            this.props.quotes.quoteToOrder(row.id, data.quickbooksCreateInvoice.data.results.body.Invoice.DocNumber, 'Pending Payment', () => {
                              alert('Quote converted to order and saved in QuickBooks.')
                              this.props.quotes.loadQuotes()
                              this.setState({
                                loadableState: false
                              })
                            })
                          } else {
                            alert(data.quickbooksCreateInvoice.data.message)
                            this.setState({
                              loadableState: false
                            })
                          }
                        })
                      })
                    })
                  })
                })
              })
            })
          })
        })
      /*
      } else {
        this.props.quotes.quoteToOrder(row.id, null, () => {
          alert('Quote converted to order.')
          this.props.quotes.loadQuotes()
          this.setState({
            loadableState: false
          })
        })
      }
      */
    }
  }

  onEmailButtonClick(row) {
    this.setState({
      activeRow: row,
      emailModalOpen: true
    });
  }

  onEmailModalClose() {
    this.setState({
      emailModalOpen: false,
      activeRow: {
        companyId: 0,
        defaultContactId: 0,
        token: ''
      }
    })
  }

  processPayment(row) {
    this.setState({
      quoteToken: row.token,
      showPaymentModal: true
    })
  }

  closePaymentModal() {
    this.setState({
      showPaymentModal: false
    })
  }

  openCreatePackingSlipForm(row) {
    this.setState({
      openCreatePackingSlipModal: true,
      quoteId: row.id
    })
  }

  closeCreatePackingSlipModal() {
    this.setState({
      openCreatePackingSlipModal: false,
      quoteId: 0
    })
  }

  formatActions(cell, row) {
    let processPaymentButton = <Button disabled bsSize="small" bsStyle="warning" id={row.id}><i className="fa fa-usd" aria-hidden="true"></i></Button>
    if (row.stripeCustomerId != '') {
      processPaymentButton = <Button active bsSize="small" bsStyle="warning" id={row.id} onClick={() => {this.processPayment(row)}}><i className="fa fa-usd" aria-hidden="true"></i></Button>
    }
    return (
      <div>
        <Button bsSize="small" bsStyle="success" id={row.id} onClick={() => { browserHistory.push('/company/editquote/' + row.companyId + '/' + row.id) }}><i className="fa fa-pencil-square-o" aria-hidden="true"></i></Button>
        <Button bsSize="small" bsStyle="info" id={row.id} onClick={() => { browserHistory.push('/quote/' + row.id) }}><i className="fa fa-file-pdf-o" aria-hidden="true"></i></Button>
        <Button bsSize="small" bsStyle="primary" id={row.id} onClick={() => { this.onEmailButtonClick(row) }}><i className="fa fa-envelope" aria-hidden="true"></i></Button>
        {processPaymentButton}
        <Button active bsSize="small" bsStyle="warning" id={row.id} onClick={() => {this.quoteToOrder(row)}}><i className="fa fa-arrow-circle-up" aria-hidden="true"></i></Button>
        <Button bsSize="small" bsStyle="success" id={ row.id } onClick={ () => { this.openCreatePackingSlipForm(row) } }><i className="fa fa-newspaper-o" aria-hidden="true"></i></Button>
        <Button bsSize="small" bsStyle="danger" id={row.id} onClick={() => { this.deleteQuote(row.id) }}><i className="fa fa-trash" aria-hidden="true"></i></Button>
      </div>
    )
  }

  render() {

    const options = {
      onAddRow: this.quoteToOrder.bind(this),
      defaultSortName: 'id',
      defaultSortOrder: 'desc'
    }

    const quotesTable = (
      <div>
        <BootstrapTable
          data={this.props.quotes.quotes}
          striped={true}
          hover={true}
          pagination={true}
          search={true}
          options={options}
          exportCSV={true}
        >
          <TableHeaderColumn width="75" dataField="id" isKey={true} dataSort={true} dataAlign="center" hiddenOnInsert={true} autoValue={true}>CRM ID</TableHeaderColumn>
          <TableHeaderColumn width="100" dataField="companyName" dataSort={true}>Company</TableHeaderColumn>
          <TableHeaderColumn width="100" dataField="quoteType" dataSort={true}>Type</TableHeaderColumn>
          <TableHeaderColumn width="100" dataField="oneTimeTotal" dataFormat={this.priceFormatter.bind(this)} dataSort={true}>Quote Total</TableHeaderColumn>
          { /* <TableHeaderColumn width="100" dataField="demoName" dataSort={true}>Demo</TableHeaderColumn> */ }
          { /* <TableHeaderColumn width="100" dataField="leaseName" dataSort={true}>Lease</TableHeaderColumn> */ }
          <TableHeaderColumn width="100" dataField="carrierName" dataSort={true}>Carrier</TableHeaderColumn>
          <TableHeaderColumn width="150" datafield="id" hiddenOnInsert={true} autoValue={true} dataFormat={this.formatActions.bind(this)}>Actions</TableHeaderColumn>
        </BootstrapTable>
      </div>
    )

    return (
      <div className="right_col" role="main" style={{ height: 'inherit' }}>
        <div className="">
          <div className="page-title">
            <div className="title_left">
              <Breadcrumb>
                <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                <Breadcrumb.Item active>Quotes</Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </div>
          <div className="clearfix"></div>
          <Loadable active={this.state.loadableState} spinner text='Processing your request...'>
            <Collapsible title="Quotes" content={quotesTable} />
          </Loadable>
        </div>
        <CreatePackingSlip open={this.state.openCreatePackingSlipModal} quoteId={this.state.quoteId} onClose={this.closeCreatePackingSlipModal.bind(this)} />
        <EmailInvoice open={this.state.emailModalOpen} companyId={this.state.activeRow.companyId} token={this.state.activeRow.token} defaultContactId={this.state.activeRow.companyDefaultContactId} onClose={this.onEmailModalClose.bind(this)} />
        <Modal show={this.state.showPaymentModal} onHide={this.closePaymentModal.bind(this)}>
          <Modal.Header closeButton>
            <Modal.Title>Charge Card On File</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <SavedCardForm quoteToken={this.state.quoteToken}/>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={() => { this.closePaymentModal() }}><i className="fa fa-ban" aria-hidden="true"></i> Cancel</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/quotes.js